import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

import timestamps from '~/services/timestamps'


export default class extends React.Component {
    static propTypes = {
		ID: PropTypes.number.isRequired,
		date: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		read_time: PropTypes.number.isRequired,
		content: PropTypes.string.isRequired,
	};

    createContent = (html) => {
		return <div dangerouslySetInnerHTML={{__html: html}} />
	};

    render() {
		return (
			<div className="body-content">
				<h1 className="entry-title">{this.props.title}</h1>
				<p className="serif">{'Posted ' + timestamps.timeSince(this.props.date)}</p>
				<p className="serif mbot30">{ this.props.read_time + ' min read' }</p>
	    		<div dangerouslySetInnerHTML={{__html: this.props.content}} />
        	</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Article/components/Content.js